/* eslint-disable */
// Do not edit this file, it is auto-generated at build time!
// See scripts/generate-component-factory.js to modify the generation of this file.
import React from 'react';
import Loadable from 'react-loadable';
const Accordion = Loadable({
    loader: () => import(/* webpackChunkName: "Accordion" */ '../components/Accordion'),
    loading: () => <div></div>,
    modules: ['Accordion'],
    });
const AccordionSimple = Loadable({
    loader: () => import(/* webpackChunkName: "AccordionSimple" */ '../components/AccordionSimple'),
    loading: () => <div></div>,
    modules: ['AccordionSimple'],
    });
const Accordionv2 = Loadable({
    loader: () => import(/* webpackChunkName: "Accordionv2" */ '../components/Accordionv2'),
    loading: () => <div></div>,
    modules: ['Accordionv2'],
    });
const AddressAndIntroduction = Loadable({
    loader: () => import(/* webpackChunkName: "AddressAndIntroduction" */ '../components/AddressAndIntroduction'),
    loading: () => <div></div>,
    modules: ['AddressAndIntroduction'],
    });
const Alert = Loadable({
    loader: () => import(/* webpackChunkName: "Alert" */ '../components/Alert'),
    loading: () => <div></div>,
    modules: ['Alert'],
    });
const Alertv2 = Loadable({
    loader: () => import(/* webpackChunkName: "Alertv2" */ '../components/Alertv2'),
    loading: () => <div></div>,
    modules: ['Alertv2'],
    });
const AlignImageText = Loadable({
    loader: () => import(/* webpackChunkName: "AlignImageText" */ '../components/AlignImageText'),
    loading: () => <div></div>,
    modules: ['AlignImageText'],
    });
const AllToolsListing = Loadable({
    loader: () => import(/* webpackChunkName: "AllToolsListing" */ '../components/AllToolsListing'),
    loading: () => <div></div>,
    modules: ['AllToolsListing'],
    });
const AlphabetFilter = Loadable({
    loader: () => import(/* webpackChunkName: "AlphabetFilter" */ '../components/AlphabetFilter'),
    loading: () => <div></div>,
    modules: ['AlphabetFilter'],
    });
const AlphabetList = Loadable({
    loader: () => import(/* webpackChunkName: "AlphabetList" */ '../components/AlphabetList'),
    loading: () => <div></div>,
    modules: ['AlphabetList'],
    });
const Anchor = Loadable({
    loader: () => import(/* webpackChunkName: "Anchor" */ '../components/Anchor'),
    loading: () => <div></div>,
    modules: ['Anchor'],
    });
const AnnouncementCoveoResultTemplate = Loadable({
    loader: () => import(/* webpackChunkName: "AnnouncementCoveoResultTemplate" */ '../components/AnnouncementCoveoResultTemplate'),
    loading: () => <div></div>,
    modules: ['AnnouncementCoveoResultTemplate'],
    });
const Announcements = Loadable({
    loader: () => import(/* webpackChunkName: "Announcements" */ '../components/Announcements'),
    loading: () => <div></div>,
    modules: ['Announcements'],
    });
const AnnouncementsList = Loadable({
    loader: () => import(/* webpackChunkName: "AnnouncementsList" */ '../components/AnnouncementsList'),
    loading: () => <div></div>,
    modules: ['AnnouncementsList'],
    });
const AnnouncementsV2 = Loadable({
    loader: () => import(/* webpackChunkName: "AnnouncementsV2" */ '../components/AnnouncementsV2'),
    loading: () => <div></div>,
    modules: ['AnnouncementsV2'],
    });
const AnnouncementsV3 = Loadable({
    loader: () => import(/* webpackChunkName: "AnnouncementsV3" */ '../components/AnnouncementsV3'),
    loading: () => <div></div>,
    modules: ['AnnouncementsV3'],
    });
const ArticleHeader = Loadable({
    loader: () => import(/* webpackChunkName: "ArticleHeader" */ '../components/ArticleHeader'),
    loading: () => <div></div>,
    modules: ['ArticleHeader'],
    });
const ArticleInfo = Loadable({
    loader: () => import(/* webpackChunkName: "ArticleInfo" */ '../components/ArticleInfo'),
    loading: () => <div></div>,
    modules: ['ArticleInfo'],
    });
const ArticleTitle = Loadable({
    loader: () => import(/* webpackChunkName: "ArticleTitle" */ '../components/ArticleTitle'),
    loading: () => <div></div>,
    modules: ['ArticleTitle'],
    });
const AutoLogin = Loadable({
    loader: () => import(/* webpackChunkName: "AutoLogin" */ '../components/AutoLogin'),
    loading: () => <div></div>,
    modules: ['AutoLogin'],
    });
const AutoRedirect = Loadable({
    loader: () => import(/* webpackChunkName: "AutoRedirect" */ '../components/AutoRedirect'),
    loading: () => <div></div>,
    modules: ['AutoRedirect'],
    });
const BannerCarousel = Loadable({
    loader: () => import(/* webpackChunkName: "BannerCarousel" */ '../components/BannerCarousel'),
    loading: () => <div></div>,
    modules: ['BannerCarousel'],
    });
const BannerRotator = Loadable({
    loader: () => import(/* webpackChunkName: "BannerRotator" */ '../components/BannerRotator'),
    loading: () => <div></div>,
    modules: ['BannerRotator'],
    });
const BasicPageBanner = Loadable({
    loader: () => import(/* webpackChunkName: "BasicPageBanner" */ '../components/BasicPageBanner'),
    loading: () => <div></div>,
    modules: ['BasicPageBanner'],
    });
const BasicPageBannerv3 = Loadable({
    loader: () => import(/* webpackChunkName: "BasicPageBannerv3" */ '../components/BasicPageBannerv3'),
    loading: () => <div></div>,
    modules: ['BasicPageBannerv3'],
    });
const BasicPageBannerv4 = Loadable({
    loader: () => import(/* webpackChunkName: "BasicPageBannerv4" */ '../components/BasicPageBannerv4'),
    loading: () => <div></div>,
    modules: ['BasicPageBannerv4'],
    });
const BioPage = Loadable({
    loader: () => import(/* webpackChunkName: "BioPage" */ '../components/BioPage'),
    loading: () => <div></div>,
    modules: ['BioPage'],
    });
const Breadcrumb = Loadable({
    loader: () => import(/* webpackChunkName: "Breadcrumb" */ '../components/Breadcrumb'),
    loading: () => <div></div>,
    modules: ['Breadcrumb'],
    });
const CalendarEmbed = Loadable({
    loader: () => import(/* webpackChunkName: "CalendarEmbed" */ '../components/CalendarEmbed'),
    loading: () => <div></div>,
    modules: ['CalendarEmbed'],
    });
const CalendarEvents = Loadable({
    loader: () => import(/* webpackChunkName: "CalendarEvents" */ '../components/CalendarEvents'),
    loading: () => <div></div>,
    modules: ['CalendarEvents'],
    });
const CalloutBanner = Loadable({
    loader: () => import(/* webpackChunkName: "CalloutBanner" */ '../components/CalloutBanner'),
    loading: () => <div></div>,
    modules: ['CalloutBanner'],
    });
const CalloutBannerFullwidth = Loadable({
    loader: () => import(/* webpackChunkName: "CalloutBannerFullwidth" */ '../components/CalloutBannerFullwidth'),
    loading: () => <div></div>,
    modules: ['CalloutBannerFullwidth'],
    });
const CalloutBannerFullWidthList = Loadable({
    loader: () => import(/* webpackChunkName: "CalloutBannerFullWidthList" */ '../components/CalloutBannerFullWidthList'),
    loading: () => <div></div>,
    modules: ['CalloutBannerFullWidthList'],
    });
const CalloutBannerInformationList = Loadable({
    loader: () => import(/* webpackChunkName: "CalloutBannerInformationList" */ '../components/CalloutBannerInformationList'),
    loading: () => <div></div>,
    modules: ['CalloutBannerInformationList'],
    });
const CalloutBannerList = Loadable({
    loader: () => import(/* webpackChunkName: "CalloutBannerList" */ '../components/CalloutBannerList'),
    loading: () => <div></div>,
    modules: ['CalloutBannerList'],
    });
const CalloutBig = Loadable({
    loader: () => import(/* webpackChunkName: "CalloutBig" */ '../components/CalloutBig'),
    loading: () => <div></div>,
    modules: ['CalloutBig'],
    });
const CalloutBox = Loadable({
    loader: () => import(/* webpackChunkName: "CalloutBox" */ '../components/CalloutBox'),
    loading: () => <div></div>,
    modules: ['CalloutBox'],
    });
const CalloutBoxTool = Loadable({
    loader: () => import(/* webpackChunkName: "CalloutBoxTool" */ '../components/CalloutBoxTool'),
    loading: () => <div></div>,
    modules: ['CalloutBoxTool'],
    });
const CalloutTiles = Loadable({
    loader: () => import(/* webpackChunkName: "CalloutTiles" */ '../components/CalloutTiles'),
    loading: () => <div></div>,
    modules: ['CalloutTiles'],
    });
const ChatBot = Loadable({
    loader: () => import(/* webpackChunkName: "ChatBot" */ '../components/ChatBot'),
    loading: () => <div></div>,
    modules: ['ChatBot'],
    });
const ContactChunk = Loadable({
    loader: () => import(/* webpackChunkName: "ContactChunk" */ '../components/ContactChunk'),
    loading: () => <div></div>,
    modules: ['ContactChunk'],
    });
const CookieBanner = Loadable({
    loader: () => import(/* webpackChunkName: "CookieBanner" */ '../components/CookieBanner'),
    loading: () => <div></div>,
    modules: ['CookieBanner'],
    });
const CoveoFinanceAndAdminSites = Loadable({
    loader: () => import(/* webpackChunkName: "CoveoFinanceAndAdminSites" */ '../components/CoveoFinanceAndAdminSites'),
    loading: () => <div></div>,
    modules: ['CoveoFinanceAndAdminSites'],
    });
const CrawledPageCoveoResultTemplate = Loadable({
    loader: () => import(/* webpackChunkName: "CrawledPageCoveoResultTemplate" */ '../components/CrawledPageCoveoResultTemplate'),
    loading: () => <div></div>,
    modules: ['CrawledPageCoveoResultTemplate'],
    });
const CTABarSpotlight = Loadable({
    loader: () => import(/* webpackChunkName: "CTABarSpotlight" */ '../components/CTABarSpotlight'),
    loading: () => <div></div>,
    modules: ['CTABarSpotlight'],
    });
const DirectoryItemCoveoResultTemplate = Loadable({
    loader: () => import(/* webpackChunkName: "DirectoryItemCoveoResultTemplate" */ '../components/DirectoryItemCoveoResultTemplate'),
    loading: () => <div></div>,
    modules: ['DirectoryItemCoveoResultTemplate'],
    });
const DocumentCoveoResultTemplate = Loadable({
    loader: () => import(/* webpackChunkName: "DocumentCoveoResultTemplate" */ '../components/DocumentCoveoResultTemplate'),
    loading: () => <div></div>,
    modules: ['DocumentCoveoResultTemplate'],
    });
const EduHeader = Loadable({
    loader: () => import(/* webpackChunkName: "EduHeader" */ '../components/EduHeader'),
    loading: () => <div></div>,
    modules: ['EduHeader'],
    });
const EmbedSingleColumn = Loadable({
    loader: () => import(/* webpackChunkName: "EmbedSingleColumn" */ '../components/EmbedSingleColumn'),
    loading: () => <div></div>,
    modules: ['EmbedSingleColumn'],
    });
const EmbedTwoColumn = Loadable({
    loader: () => import(/* webpackChunkName: "EmbedTwoColumn" */ '../components/EmbedTwoColumn'),
    loading: () => <div></div>,
    modules: ['EmbedTwoColumn'],
    });
const EventsCategory = Loadable({
    loader: () => import(/* webpackChunkName: "EventsCategory" */ '../components/EventsCategory'),
    loading: () => <div></div>,
    modules: ['EventsCategory'],
    });
const EventsInfo = Loadable({
    loader: () => import(/* webpackChunkName: "EventsInfo" */ '../components/EventsInfo'),
    loading: () => <div></div>,
    modules: ['EventsInfo'],
    });
const EventsListing = Loadable({
    loader: () => import(/* webpackChunkName: "EventsListing" */ '../components/EventsListing'),
    loading: () => <div></div>,
    modules: ['EventsListing'],
    });
const EventsListingHeader = Loadable({
    loader: () => import(/* webpackChunkName: "EventsListingHeader" */ '../components/EventsListingHeader'),
    loading: () => <div></div>,
    modules: ['EventsListingHeader'],
    });
const EventWidget = Loadable({
    loader: () => import(/* webpackChunkName: "EventWidget" */ '../components/EventWidget'),
    loading: () => <div></div>,
    modules: ['EventWidget'],
    });
const ExternalSourcesToggle = Loadable({
    loader: () => import(/* webpackChunkName: "ExternalSourcesToggle" */ '../components/ExternalSourcesToggle'),
    loading: () => <div></div>,
    modules: ['ExternalSourcesToggle'],
    });
const Factoids = Loadable({
    loader: () => import(/* webpackChunkName: "Factoids" */ '../components/Factoids'),
    loading: () => <div></div>,
    modules: ['Factoids'],
    });
const FavoritesList = Loadable({
    loader: () => import(/* webpackChunkName: "FavoritesList" */ '../components/FavoritesList'),
    loading: () => <div></div>,
    modules: ['FavoritesList'],
    });
const Footer = Loadable({
    loader: () => import(/* webpackChunkName: "Footer" */ '../components/Footer'),
    loading: () => <div></div>,
    modules: ['Footer'],
    });
const Footerv2 = Loadable({
    loader: () => import(/* webpackChunkName: "Footerv2" */ '../components/Footerv2'),
    loading: () => <div></div>,
    modules: ['Footerv2'],
    });
const Form = Loadable({
    loader: () => import(/* webpackChunkName: "Form" */ '../components/Form'),
    loading: () => <div></div>,
    modules: ['Form'],
    });
const FormWithCaptcha = Loadable({
    loader: () => import(/* webpackChunkName: "FormWithCaptcha" */ '../components/FormWithCaptcha'),
    loading: () => <div></div>,
    modules: ['FormWithCaptcha'],
    });
const GeneralHeader = Loadable({
    loader: () => import(/* webpackChunkName: "GeneralHeader" */ '../components/GeneralHeader'),
    loading: () => <div></div>,
    modules: ['GeneralHeader'],
    });
const GeneralHeaderv2 = Loadable({
    loader: () => import(/* webpackChunkName: "GeneralHeaderv2" */ '../components/GeneralHeaderv2'),
    loading: () => <div></div>,
    modules: ['GeneralHeaderv2'],
    });
const GlossaryList = Loadable({
    loader: () => import(/* webpackChunkName: "GlossaryList" */ '../components/GlossaryList'),
    loading: () => <div></div>,
    modules: ['GlossaryList'],
    });
const GoogleSearchBox = Loadable({
    loader: () => import(/* webpackChunkName: "GoogleSearchBox" */ '../components/GoogleSearchBox'),
    loading: () => <div></div>,
    modules: ['GoogleSearchBox'],
    });
const GraphqlExample = Loadable({
    loader: () => import(/* webpackChunkName: "GraphqlExample" */ '../components/GraphqlExample'),
    loading: () => <div></div>,
    modules: ['GraphqlExample'],
    });
const Header = Loadable({
    loader: () => import(/* webpackChunkName: "Header" */ '../components/Header'),
    loading: () => <div></div>,
    modules: ['Header'],
    });
const Headerv2 = Loadable({
    loader: () => import(/* webpackChunkName: "Headerv2" */ '../components/Headerv2'),
    loading: () => <div></div>,
    modules: ['Headerv2'],
    });
const Headerv3 = Loadable({
    loader: () => import(/* webpackChunkName: "Headerv3" */ '../components/Headerv3'),
    loading: () => <div></div>,
    modules: ['Headerv3'],
    });
const Headerv4 = Loadable({
    loader: () => import(/* webpackChunkName: "Headerv4" */ '../components/Headerv4'),
    loading: () => <div></div>,
    modules: ['Headerv4'],
    });
const HeadlineBar = Loadable({
    loader: () => import(/* webpackChunkName: "HeadlineBar" */ '../components/HeadlineBar'),
    loading: () => <div></div>,
    modules: ['HeadlineBar'],
    });
const HeadlineTextBold = Loadable({
    loader: () => import(/* webpackChunkName: "HeadlineTextBold" */ '../components/HeadlineTextBold'),
    loading: () => <div></div>,
    modules: ['HeadlineTextBold'],
    });
const HeadlineTextSmall = Loadable({
    loader: () => import(/* webpackChunkName: "HeadlineTextSmall" */ '../components/HeadlineTextSmall'),
    loading: () => <div></div>,
    modules: ['HeadlineTextSmall'],
    });
const HorizontalTab = Loadable({
    loader: () => import(/* webpackChunkName: "HorizontalTab" */ '../components/HorizontalTab'),
    loading: () => <div></div>,
    modules: ['HorizontalTab'],
    });
const HorizontalTabs = Loadable({
    loader: () => import(/* webpackChunkName: "HorizontalTabs" */ '../components/HorizontalTabs'),
    loading: () => <div></div>,
    modules: ['HorizontalTabs'],
    });
const HorizontalTabsV2 = Loadable({
    loader: () => import(/* webpackChunkName: "HorizontalTabsV2" */ '../components/HorizontalTabsV2'),
    loading: () => <div></div>,
    modules: ['HorizontalTabsV2'],
    });
const HTMLBlock = Loadable({
    loader: () => import(/* webpackChunkName: "HTMLBlock" */ '../components/HTMLBlock'),
    loading: () => <div></div>,
    modules: ['HTMLBlock'],
    });
const ImageLeftRight = Loadable({
    loader: () => import(/* webpackChunkName: "ImageLeftRight" */ '../components/ImageLeftRight'),
    loading: () => <div></div>,
    modules: ['ImageLeftRight'],
    });
const ImageSpotlight = Loadable({
    loader: () => import(/* webpackChunkName: "ImageSpotlight" */ '../components/ImageSpotlight'),
    loading: () => <div></div>,
    modules: ['ImageSpotlight'],
    });
const ImageSpotlightRandom = Loadable({
    loader: () => import(/* webpackChunkName: "ImageSpotlightRandom" */ '../components/ImageSpotlightRandom'),
    loading: () => <div></div>,
    modules: ['ImageSpotlightRandom'],
    });
const ImageSpotlightv2 = Loadable({
    loader: () => import(/* webpackChunkName: "ImageSpotlightv2" */ '../components/ImageSpotlightv2'),
    loading: () => <div></div>,
    modules: ['ImageSpotlightv2'],
    });
const ImageTileGrid = Loadable({
    loader: () => import(/* webpackChunkName: "ImageTileGrid" */ '../components/ImageTileGrid'),
    loading: () => <div></div>,
    modules: ['ImageTileGrid'],
    });
const ImageWithCaption = Loadable({
    loader: () => import(/* webpackChunkName: "ImageWithCaption" */ '../components/ImageWithCaption'),
    loading: () => <div></div>,
    modules: ['ImageWithCaption'],
    });
const ImportedNewsArticleCoveoResultTemplate = Loadable({
    loader: () => import(/* webpackChunkName: "ImportedNewsArticleCoveoResultTemplate" */ '../components/ImportedNewsArticleCoveoResultTemplate'),
    loading: () => <div></div>,
    modules: ['ImportedNewsArticleCoveoResultTemplate'],
    });
const InfoTile = Loadable({
    loader: () => import(/* webpackChunkName: "InfoTile" */ '../components/InfoTile'),
    loading: () => <div></div>,
    modules: ['InfoTile'],
    });
const InteractiveMap = Loadable({
    loader: () => import(/* webpackChunkName: "InteractiveMap" */ '../components/InteractiveMap'),
    loading: () => <div></div>,
    modules: ['InteractiveMap'],
    });
const IntranetSnippet = Loadable({
    loader: () => import(/* webpackChunkName: "IntranetSnippet" */ '../components/IntranetSnippet'),
    loading: () => <div></div>,
    modules: ['IntranetSnippet'],
    });
const JumpToLink = Loadable({
    loader: () => import(/* webpackChunkName: "JumpToLink" */ '../components/JumpToLink'),
    loading: () => <div></div>,
    modules: ['JumpToLink'],
    });
const KBArticlesCoveoResultTemplate = Loadable({
    loader: () => import(/* webpackChunkName: "KBArticlesCoveoResultTemplate" */ '../components/KBArticlesCoveoResultTemplate'),
    loading: () => <div></div>,
    modules: ['KBArticlesCoveoResultTemplate'],
    });
const KnowledgeBaseCoveoResultTemplate = Loadable({
    loader: () => import(/* webpackChunkName: "KnowledgeBaseCoveoResultTemplate" */ '../components/KnowledgeBaseCoveoResultTemplate'),
    loading: () => <div></div>,
    modules: ['KnowledgeBaseCoveoResultTemplate'],
    });
const LeftNav = Loadable({
    loader: () => import(/* webpackChunkName: "LeftNav" */ '../components/LeftNav'),
    loading: () => <div></div>,
    modules: ['LeftNav'],
    });
const LeftNavigation = Loadable({
    loader: () => import(/* webpackChunkName: "LeftNavigation" */ '../components/LeftNavigation'),
    loading: () => <div></div>,
    modules: ['LeftNavigation'],
    });
const LeftNavigationv2 = Loadable({
    loader: () => import(/* webpackChunkName: "LeftNavigationv2" */ '../components/LeftNavigationv2'),
    loading: () => <div></div>,
    modules: ['LeftNavigationv2'],
    });
const LinkListing = Loadable({
    loader: () => import(/* webpackChunkName: "LinkListing" */ '../components/LinkListing'),
    loading: () => <div></div>,
    modules: ['LinkListing'],
    });
const LoginTile = Loadable({
    loader: () => import(/* webpackChunkName: "LoginTile" */ '../components/LoginTile'),
    loading: () => <div></div>,
    modules: ['LoginTile'],
    });
const LoginTileV2 = Loadable({
    loader: () => import(/* webpackChunkName: "LoginTileV2" */ '../components/LoginTileV2'),
    loading: () => <div></div>,
    modules: ['LoginTileV2'],
    });
const Moments = Loadable({
    loader: () => import(/* webpackChunkName: "Moments" */ '../components/Moments'),
    loading: () => <div></div>,
    modules: ['Moments'],
    });
const NewsDetailSiteSearchCoveoResultTemplate = Loadable({
    loader: () => import(/* webpackChunkName: "NewsDetailSiteSearchCoveoResultTemplate" */ '../components/NewsDetailSiteSearchCoveoResultTemplate'),
    loading: () => <div></div>,
    modules: ['NewsDetailSiteSearchCoveoResultTemplate'],
    });
const NewsFeatured = Loadable({
    loader: () => import(/* webpackChunkName: "NewsFeatured" */ '../components/NewsFeatured'),
    loading: () => <div></div>,
    modules: ['NewsFeatured'],
    });
const NewsFeaturedUsingSubscriptions = Loadable({
    loader: () => import(/* webpackChunkName: "NewsFeaturedUsingSubscriptions" */ '../components/NewsFeaturedUsingSubscriptions'),
    loading: () => <div></div>,
    modules: ['NewsFeaturedUsingSubscriptions'],
    });
const NewsFeaturedV2 = Loadable({
    loader: () => import(/* webpackChunkName: "NewsFeaturedV2" */ '../components/NewsFeaturedV2'),
    loading: () => <div></div>,
    modules: ['NewsFeaturedV2'],
    });
const NewsImageWithCaption = Loadable({
    loader: () => import(/* webpackChunkName: "NewsImageWithCaption" */ '../components/NewsImageWithCaption'),
    loading: () => <div></div>,
    modules: ['NewsImageWithCaption'],
    });
const NewsList = Loadable({
    loader: () => import(/* webpackChunkName: "NewsList" */ '../components/NewsList'),
    loading: () => <div></div>,
    modules: ['NewsList'],
    });
const NewsListingNavigation = Loadable({
    loader: () => import(/* webpackChunkName: "NewsListingNavigation" */ '../components/NewsListingNavigation'),
    loading: () => <div></div>,
    modules: ['NewsListingNavigation'],
    });
const NewsListV2 = Loadable({
    loader: () => import(/* webpackChunkName: "NewsListV2" */ '../components/NewsListV2'),
    loading: () => <div></div>,
    modules: ['NewsListV2'],
    });
const NewsSearch = Loadable({
    loader: () => import(/* webpackChunkName: "NewsSearch" */ '../components/NewsSearch'),
    loading: () => <div></div>,
    modules: ['NewsSearch'],
    });
const NewsSearchV2 = Loadable({
    loader: () => import(/* webpackChunkName: "NewsSearchV2" */ '../components/NewsSearchV2'),
    loading: () => <div></div>,
    modules: ['NewsSearchV2'],
    });
const NewsSubscriptions = Loadable({
    loader: () => import(/* webpackChunkName: "NewsSubscriptions" */ '../components/NewsSubscriptions'),
    loading: () => <div></div>,
    modules: ['NewsSubscriptions'],
    });
const Notifications = Loadable({
    loader: () => import(/* webpackChunkName: "Notifications" */ '../components/Notifications'),
    loading: () => <div></div>,
    modules: ['Notifications'],
    });
const PageBanner = Loadable({
    loader: () => import(/* webpackChunkName: "PageBanner" */ '../components/PageBanner'),
    loading: () => <div></div>,
    modules: ['PageBanner'],
    });
const PageCoveoResultTemplate = Loadable({
    loader: () => import(/* webpackChunkName: "PageCoveoResultTemplate" */ '../components/PageCoveoResultTemplate'),
    loading: () => <div></div>,
    modules: ['PageCoveoResultTemplate'],
    });
const PageHeroBanner = Loadable({
    loader: () => import(/* webpackChunkName: "PageHeroBanner" */ '../components/PageHeroBanner'),
    loading: () => <div></div>,
    modules: ['PageHeroBanner'],
    });
const PeopleCoveoResultTemplate = Loadable({
    loader: () => import(/* webpackChunkName: "PeopleCoveoResultTemplate" */ '../components/PeopleCoveoResultTemplate'),
    loading: () => <div></div>,
    modules: ['PeopleCoveoResultTemplate'],
    });
const PeopleDirectoryLink = Loadable({
    loader: () => import(/* webpackChunkName: "PeopleDirectoryLink" */ '../components/PeopleDirectoryLink'),
    loading: () => <div></div>,
    modules: ['PeopleDirectoryLink'],
    });
const PeopleListing = Loadable({
    loader: () => import(/* webpackChunkName: "PeopleListing" */ '../components/PeopleListing'),
    loading: () => <div></div>,
    modules: ['PeopleListing'],
    });
const PeopleListingTwoColv2 = Loadable({
    loader: () => import(/* webpackChunkName: "PeopleListingTwoColv2" */ '../components/PeopleListingTwoColv2'),
    loading: () => <div></div>,
    modules: ['PeopleListingTwoColv2'],
    });
const PeopleListingVertical = Loadable({
    loader: () => import(/* webpackChunkName: "PeopleListingVertical" */ '../components/PeopleListingVertical'),
    loading: () => <div></div>,
    modules: ['PeopleListingVertical'],
    });
const PersonCardCoveoResultTemplate = Loadable({
    loader: () => import(/* webpackChunkName: "PersonCardCoveoResultTemplate" */ '../components/PersonCardCoveoResultTemplate'),
    loading: () => <div></div>,
    modules: ['PersonCardCoveoResultTemplate'],
    });
const PhotoTabs = Loadable({
    loader: () => import(/* webpackChunkName: "PhotoTabs" */ '../components/PhotoTabs'),
    loading: () => <div></div>,
    modules: ['PhotoTabs'],
    });
const ProfileHeader = Loadable({
    loader: () => import(/* webpackChunkName: "ProfileHeader" */ '../components/ProfileHeader'),
    loading: () => <div></div>,
    modules: ['ProfileHeader'],
    });
const PullQuote = Loadable({
    loader: () => import(/* webpackChunkName: "PullQuote" */ '../components/PullQuote'),
    loading: () => <div></div>,
    modules: ['PullQuote'],
    });
const QuickLinks = Loadable({
    loader: () => import(/* webpackChunkName: "QuickLinks" */ '../components/QuickLinks'),
    loading: () => <div></div>,
    modules: ['QuickLinks'],
    });
const QuickNotes = Loadable({
    loader: () => import(/* webpackChunkName: "QuickNotes" */ '../components/QuickNotes'),
    loading: () => <div></div>,
    modules: ['QuickNotes'],
    });
const QuickTakeaways = Loadable({
    loader: () => import(/* webpackChunkName: "QuickTakeaways" */ '../components/QuickTakeaways'),
    loading: () => <div></div>,
    modules: ['QuickTakeaways'],
    });
const RawContent = Loadable({
    loader: () => import(/* webpackChunkName: "RawContent" */ '../components/RawContent'),
    loading: () => <div></div>,
    modules: ['RawContent'],
    });
const ReadingList = Loadable({
    loader: () => import(/* webpackChunkName: "ReadingList" */ '../components/ReadingList'),
    loading: () => <div></div>,
    modules: ['ReadingList'],
    });
const RelatedNews = Loadable({
    loader: () => import(/* webpackChunkName: "RelatedNews" */ '../components/RelatedNews'),
    loading: () => <div></div>,
    modules: ['RelatedNews'],
    });
const RelatedTopics = Loadable({
    loader: () => import(/* webpackChunkName: "RelatedTopics" */ '../components/RelatedTopics'),
    loading: () => <div></div>,
    modules: ['RelatedTopics'],
    });
const ResourcesListing = Loadable({
    loader: () => import(/* webpackChunkName: "ResourcesListing" */ '../components/ResourcesListing'),
    loading: () => <div></div>,
    modules: ['ResourcesListing'],
    });
const RichText1 = Loadable({
    loader: () => import(/* webpackChunkName: "RichText1" */ '../components/RichText1'),
    loading: () => <div></div>,
    modules: ['RichText1'],
    });
const RichText2 = Loadable({
    loader: () => import(/* webpackChunkName: "RichText2" */ '../components/RichText2'),
    loading: () => <div></div>,
    modules: ['RichText2'],
    });
const RichText3 = Loadable({
    loader: () => import(/* webpackChunkName: "RichText3" */ '../components/RichText3'),
    loading: () => <div></div>,
    modules: ['RichText3'],
    });
const RichText4 = Loadable({
    loader: () => import(/* webpackChunkName: "RichText4" */ '../components/RichText4'),
    loading: () => <div></div>,
    modules: ['RichText4'],
    });
const RichText5 = Loadable({
    loader: () => import(/* webpackChunkName: "RichText5" */ '../components/RichText5'),
    loading: () => <div></div>,
    modules: ['RichText5'],
    });
const SearchAlert = Loadable({
    loader: () => import(/* webpackChunkName: "SearchAlert" */ '../components/SearchAlert'),
    loading: () => <div></div>,
    modules: ['SearchAlert'],
    });
const SearchContent = Loadable({
    loader: () => import(/* webpackChunkName: "SearchContent" */ '../components/SearchContent'),
    loading: () => <div></div>,
    modules: ['SearchContent'],
    });
const SearchSortDropdown = Loadable({
    loader: () => import(/* webpackChunkName: "SearchSortDropdown" */ '../components/SearchSortDropdown'),
    loading: () => <div></div>,
    modules: ['SearchSortDropdown'],
    });
const SectionWrap = Loadable({
    loader: () => import(/* webpackChunkName: "SectionWrap" */ '../components/SectionWrap'),
    loading: () => <div></div>,
    modules: ['SectionWrap'],
    });
const SideScroller = Loadable({
    loader: () => import(/* webpackChunkName: "SideScroller" */ '../components/SideScroller'),
    loading: () => <div></div>,
    modules: ['SideScroller'],
    });
const SingleColumnLayout = Loadable({
    loader: () => import(/* webpackChunkName: "SingleColumnLayout" */ '../components/SingleColumnLayout'),
    loading: () => <div></div>,
    modules: ['SingleColumnLayout'],
    });
const SingleColumnWideLayout = Loadable({
    loader: () => import(/* webpackChunkName: "SingleColumnWideLayout" */ '../components/SingleColumnWideLayout'),
    loading: () => <div></div>,
    modules: ['SingleColumnWideLayout'],
    });
const SingleColumnWideLayoutv2 = Loadable({
    loader: () => import(/* webpackChunkName: "SingleColumnWideLayoutv2" */ '../components/SingleColumnWideLayoutv2'),
    loading: () => <div></div>,
    modules: ['SingleColumnWideLayoutv2'],
    });
const SiteSearch = Loadable({
    loader: () => import(/* webpackChunkName: "SiteSearch" */ '../components/SiteSearch'),
    loading: () => <div></div>,
    modules: ['SiteSearch'],
    });
const Snippet = Loadable({
    loader: () => import(/* webpackChunkName: "Snippet" */ '../components/Snippet'),
    loading: () => <div></div>,
    modules: ['Snippet'],
    });
const SocialMediaIconsBar = Loadable({
    loader: () => import(/* webpackChunkName: "SocialMediaIconsBar" */ '../components/SocialMediaIconsBar'),
    loading: () => <div></div>,
    modules: ['SocialMediaIconsBar'],
    });
const SpotlightCarousel = Loadable({
    loader: () => import(/* webpackChunkName: "SpotlightCarousel" */ '../components/SpotlightCarousel'),
    loading: () => <div></div>,
    modules: ['SpotlightCarousel'],
    });
const SpotlightCarouselv2 = Loadable({
    loader: () => import(/* webpackChunkName: "SpotlightCarouselv2" */ '../components/SpotlightCarouselv2'),
    loading: () => <div></div>,
    modules: ['SpotlightCarouselv2'],
    });
const SubNavRelatedLinks = Loadable({
    loader: () => import(/* webpackChunkName: "SubNavRelatedLinks" */ '../components/SubNavRelatedLinks'),
    loading: () => <div></div>,
    modules: ['SubNavRelatedLinks'],
    });
const ThreeColumnLayout = Loadable({
    loader: () => import(/* webpackChunkName: "ThreeColumnLayout" */ '../components/ThreeColumnLayout'),
    loading: () => <div></div>,
    modules: ['ThreeColumnLayout'],
    });
const TimelineCarousel = Loadable({
    loader: () => import(/* webpackChunkName: "TimelineCarousel" */ '../components/TimelineCarousel'),
    loading: () => <div></div>,
    modules: ['TimelineCarousel'],
    });
const ToolsAndAppsCoveoResultTemplate = Loadable({
    loader: () => import(/* webpackChunkName: "ToolsAndAppsCoveoResultTemplate" */ '../components/ToolsAndAppsCoveoResultTemplate'),
    loading: () => <div></div>,
    modules: ['ToolsAndAppsCoveoResultTemplate'],
    });
const ToolsList = Loadable({
    loader: () => import(/* webpackChunkName: "ToolsList" */ '../components/ToolsList'),
    loading: () => <div></div>,
    modules: ['ToolsList'],
    });
const ToolsListing = Loadable({
    loader: () => import(/* webpackChunkName: "ToolsListing" */ '../components/ToolsListing'),
    loading: () => <div></div>,
    modules: ['ToolsListing'],
    });
const ToolsSearch = Loadable({
    loader: () => import(/* webpackChunkName: "ToolsSearch" */ '../components/ToolsSearch'),
    loading: () => <div></div>,
    modules: ['ToolsSearch'],
    });
const TwitterFeed = Loadable({
    loader: () => import(/* webpackChunkName: "TwitterFeed" */ '../components/TwitterFeed'),
    loading: () => <div></div>,
    modules: ['TwitterFeed'],
    });
const TwoColumnLeftLayout = Loadable({
    loader: () => import(/* webpackChunkName: "TwoColumnLeftLayout" */ '../components/TwoColumnLeftLayout'),
    loading: () => <div></div>,
    modules: ['TwoColumnLeftLayout'],
    });
const TwoColumnLeftLayoutv2 = Loadable({
    loader: () => import(/* webpackChunkName: "TwoColumnLeftLayoutv2" */ '../components/TwoColumnLeftLayoutv2'),
    loading: () => <div></div>,
    modules: ['TwoColumnLeftLayoutv2'],
    });
const TwoColumnLeftLayoutv3 = Loadable({
    loader: () => import(/* webpackChunkName: "TwoColumnLeftLayoutv3" */ '../components/TwoColumnLeftLayoutv3'),
    loading: () => <div></div>,
    modules: ['TwoColumnLeftLayoutv3'],
    });
const TwoColumnRightLayout = Loadable({
    loader: () => import(/* webpackChunkName: "TwoColumnRightLayout" */ '../components/TwoColumnRightLayout'),
    loading: () => <div></div>,
    modules: ['TwoColumnRightLayout'],
    });
const TwoColumnRightLayoutv2 = Loadable({
    loader: () => import(/* webpackChunkName: "TwoColumnRightLayoutv2" */ '../components/TwoColumnRightLayoutv2'),
    loading: () => <div></div>,
    modules: ['TwoColumnRightLayoutv2'],
    });
const TwoColumnRightLayoutv3 = Loadable({
    loader: () => import(/* webpackChunkName: "TwoColumnRightLayoutv3" */ '../components/TwoColumnRightLayoutv3'),
    loading: () => <div></div>,
    modules: ['TwoColumnRightLayoutv3'],
    });
const UcCoveoDidYouMean = Loadable({
    loader: () => import(/* webpackChunkName: "UcCoveoDidYouMean" */ '../components/UcCoveoDidYouMean'),
    loading: () => <div></div>,
    modules: ['UcCoveoDidYouMean'],
    });
const VideoInline = Loadable({
    loader: () => import(/* webpackChunkName: "VideoInline" */ '../components/VideoInline'),
    loading: () => <div></div>,
    modules: ['VideoInline'],
    });
const VideoInlineLeftRight = Loadable({
    loader: () => import(/* webpackChunkName: "VideoInlineLeftRight" */ '../components/VideoInlineLeftRight'),
    loading: () => <div></div>,
    modules: ['VideoInlineLeftRight'],
    });
const VideoSpotlight = Loadable({
    loader: () => import(/* webpackChunkName: "VideoSpotlight" */ '../components/VideoSpotlight'),
    loading: () => <div></div>,
    modules: ['VideoSpotlight'],
    });
const VideoSpotlightHero = Loadable({
    loader: () => import(/* webpackChunkName: "VideoSpotlightHero" */ '../components/VideoSpotlightHero'),
    loading: () => <div></div>,
    modules: ['VideoSpotlightHero'],
    });
const VimeoVideoSpotlight = Loadable({
    loader: () => import(/* webpackChunkName: "VimeoVideoSpotlight" */ '../components/VimeoVideoSpotlight'),
    loading: () => <div></div>,
    modules: ['VimeoVideoSpotlight'],
    });
const Welcome = Loadable({
    loader: () => import(/* webpackChunkName: "Welcome" */ '../components/Welcome'),
    loading: () => <div></div>,
    modules: ['Welcome'],
    });
const WelcomeImageBanner = Loadable({
    loader: () => import(/* webpackChunkName: "WelcomeImageBanner" */ '../components/WelcomeImageBanner'),
    loading: () => <div></div>,
    modules: ['WelcomeImageBanner'],
    });
const WelcomeTwoColumnLayout = Loadable({
    loader: () => import(/* webpackChunkName: "WelcomeTwoColumnLayout" */ '../components/WelcomeTwoColumnLayout'),
    loading: () => <div></div>,
    modules: ['WelcomeTwoColumnLayout'],
    });
const YoutubeCoveoResultTemplate = Loadable({
    loader: () => import(/* webpackChunkName: "YoutubeCoveoResultTemplate" */ '../components/YoutubeCoveoResultTemplate'),
    loading: () => <div></div>,
    modules: ['YoutubeCoveoResultTemplate'],
    });
import {
	CoveoAnalytics,
	CoveoAutomaticBoosting,
	CoveoBreadcrumb,
	CoveoDefaultResultTemplate,
	CoveoDidYouMean,
	CoveoExternalComponentsSection,
	CoveoExternalContent,
	CoveoFacet,
	CoveoFacetSlider,
	CoveoFacetsSection,
	CoveoGlobalSearchSection,
	CoveoHostedSearchPage,
	CoveoItemResultTemplate,
	CoveoModularFrame,
	CoveoPager,
	CoveoQueryFilter,
	CoveoQueryRanking,
	CoveoQuerySummary,
	CoveoResultList,
	CoveoResultsHeaderSection,
	CoveoResultsPerPage,
	CoveoResultsSection,
	CoveoResultsSortsSection,
	CoveoResultsSummarySection,
	CoveoSearchbox,
	CoveoSearchInterface,
	CoveoSearchResources,
	CoveoSearchSection,
	CoveoSitecoreInstanceFilter,
	CoveoSort,
	CoveoTab,
	CoveoTabsSection
} from 'coveoforsitecore-jss';

const components = new Map();
components.set('Accordion', Accordion);
components.set('AccordionSimple', AccordionSimple);
components.set('Accordionv2', Accordionv2);
components.set('AddressAndIntroduction', AddressAndIntroduction);
components.set('Alert', Alert);
components.set('Alertv2', Alertv2);
components.set('AlignImageText', AlignImageText);
components.set('AllToolsListing', AllToolsListing);
components.set('AlphabetFilter', AlphabetFilter);
components.set('AlphabetList', AlphabetList);
components.set('Anchor', Anchor);
components.set('AnnouncementCoveoResultTemplate', AnnouncementCoveoResultTemplate);
components.set('Announcements', Announcements);
components.set('AnnouncementsList', AnnouncementsList);
components.set('AnnouncementsV2', AnnouncementsV2);
components.set('AnnouncementsV3', AnnouncementsV3);
components.set('ArticleHeader', ArticleHeader);
components.set('ArticleInfo', ArticleInfo);
components.set('ArticleTitle', ArticleTitle);
components.set('AutoLogin', AutoLogin);
components.set('AutoRedirect', AutoRedirect);
components.set('BannerCarousel', BannerCarousel);
components.set('BannerRotator', BannerRotator);
components.set('BasicPageBanner', BasicPageBanner);
components.set('BasicPageBannerv3', BasicPageBannerv3);
components.set('BasicPageBannerv4', BasicPageBannerv4);
components.set('BioPage', BioPage);
components.set('Breadcrumb', Breadcrumb);
components.set('CalendarEmbed', CalendarEmbed);
components.set('CalendarEvents', CalendarEvents);
components.set('CalloutBanner', CalloutBanner);
components.set('CalloutBannerFullwidth', CalloutBannerFullwidth);
components.set('CalloutBannerFullWidthList', CalloutBannerFullWidthList);
components.set('CalloutBannerInformationList', CalloutBannerInformationList);
components.set('CalloutBannerList', CalloutBannerList);
components.set('CalloutBig', CalloutBig);
components.set('CalloutBox', CalloutBox);
components.set('CalloutBoxTool', CalloutBoxTool);
components.set('CalloutTiles', CalloutTiles);
components.set('ChatBot', ChatBot);
components.set('ContactChunk', ContactChunk);
components.set('CookieBanner', CookieBanner);
components.set('CoveoFinanceAndAdminSites', CoveoFinanceAndAdminSites);
components.set('CrawledPageCoveoResultTemplate', CrawledPageCoveoResultTemplate);
components.set('CTABarSpotlight', CTABarSpotlight);
components.set('DirectoryItemCoveoResultTemplate', DirectoryItemCoveoResultTemplate);
components.set('DocumentCoveoResultTemplate', DocumentCoveoResultTemplate);
components.set('EduHeader', EduHeader);
components.set('EmbedSingleColumn', EmbedSingleColumn);
components.set('EmbedTwoColumn', EmbedTwoColumn);
components.set('EventsCategory', EventsCategory);
components.set('EventsInfo', EventsInfo);
components.set('EventsListing', EventsListing);
components.set('EventsListingHeader', EventsListingHeader);
components.set('EventWidget', EventWidget);
components.set('ExternalSourcesToggle', ExternalSourcesToggle);
components.set('Factoids', Factoids);
components.set('FavoritesList', FavoritesList);
components.set('Footer', Footer);
components.set('Footerv2', Footerv2);
components.set('Form', Form);
components.set('FormWithCaptcha', FormWithCaptcha);
components.set('GeneralHeader', GeneralHeader);
components.set('GeneralHeaderv2', GeneralHeaderv2);
components.set('GlossaryList', GlossaryList);
components.set('GoogleSearchBox', GoogleSearchBox);
components.set('GraphqlExample', GraphqlExample);
components.set('Header', Header);
components.set('Headerv2', Headerv2);
components.set('Headerv3', Headerv3);
components.set('Headerv4', Headerv4);
components.set('HeadlineBar', HeadlineBar);
components.set('HeadlineTextBold', HeadlineTextBold);
components.set('HeadlineTextSmall', HeadlineTextSmall);
components.set('HorizontalTab', HorizontalTab);
components.set('HorizontalTabs', HorizontalTabs);
components.set('HorizontalTabsV2', HorizontalTabsV2);
components.set('HTMLBlock', HTMLBlock);
components.set('ImageLeftRight', ImageLeftRight);
components.set('ImageSpotlight', ImageSpotlight);
components.set('ImageSpotlightRandom', ImageSpotlightRandom);
components.set('ImageSpotlightv2', ImageSpotlightv2);
components.set('ImageTileGrid', ImageTileGrid);
components.set('ImageWithCaption', ImageWithCaption);
components.set('ImportedNewsArticleCoveoResultTemplate', ImportedNewsArticleCoveoResultTemplate);
components.set('InfoTile', InfoTile);
components.set('InteractiveMap', InteractiveMap);
components.set('IntranetSnippet', IntranetSnippet);
components.set('JumpToLink', JumpToLink);
components.set('KBArticlesCoveoResultTemplate', KBArticlesCoveoResultTemplate);
components.set('KnowledgeBaseCoveoResultTemplate', KnowledgeBaseCoveoResultTemplate);
components.set('LeftNav', LeftNav);
components.set('LeftNavigation', LeftNavigation);
components.set('LeftNavigationv2', LeftNavigationv2);
components.set('LinkListing', LinkListing);
components.set('LoginTile', LoginTile);
components.set('LoginTileV2', LoginTileV2);
components.set('Moments', Moments);
components.set('NewsDetailSiteSearchCoveoResultTemplate', NewsDetailSiteSearchCoveoResultTemplate);
components.set('NewsFeatured', NewsFeatured);
components.set('NewsFeaturedUsingSubscriptions', NewsFeaturedUsingSubscriptions);
components.set('NewsFeaturedV2', NewsFeaturedV2);
components.set('NewsImageWithCaption', NewsImageWithCaption);
components.set('NewsList', NewsList);
components.set('NewsListingNavigation', NewsListingNavigation);
components.set('NewsListV2', NewsListV2);
components.set('NewsSearch', NewsSearch);
components.set('NewsSearchV2', NewsSearchV2);
components.set('NewsSubscriptions', NewsSubscriptions);
components.set('Notifications', Notifications);
components.set('PageBanner', PageBanner);
components.set('PageCoveoResultTemplate', PageCoveoResultTemplate);
components.set('PageHeroBanner', PageHeroBanner);
components.set('PeopleCoveoResultTemplate', PeopleCoveoResultTemplate);
components.set('PeopleDirectoryLink', PeopleDirectoryLink);
components.set('PeopleListing', PeopleListing);
components.set('PeopleListingTwoColv2', PeopleListingTwoColv2);
components.set('PeopleListingVertical', PeopleListingVertical);
components.set('PersonCardCoveoResultTemplate', PersonCardCoveoResultTemplate);
components.set('PhotoTabs', PhotoTabs);
components.set('ProfileHeader', ProfileHeader);
components.set('PullQuote', PullQuote);
components.set('QuickLinks', QuickLinks);
components.set('QuickNotes', QuickNotes);
components.set('QuickTakeaways', QuickTakeaways);
components.set('RawContent', RawContent);
components.set('ReadingList', ReadingList);
components.set('RelatedNews', RelatedNews);
components.set('RelatedTopics', RelatedTopics);
components.set('ResourcesListing', ResourcesListing);
components.set('RichText1', RichText1);
components.set('RichText2', RichText2);
components.set('RichText3', RichText3);
components.set('RichText4', RichText4);
components.set('RichText5', RichText5);
components.set('SearchAlert', SearchAlert);
components.set('SearchContent', SearchContent);
components.set('SearchSortDropdown', SearchSortDropdown);
components.set('SectionWrap', SectionWrap);
components.set('SideScroller', SideScroller);
components.set('SingleColumnLayout', SingleColumnLayout);
components.set('SingleColumnWideLayout', SingleColumnWideLayout);
components.set('SingleColumnWideLayoutv2', SingleColumnWideLayoutv2);
components.set('SiteSearch', SiteSearch);
components.set('Snippet', Snippet);
components.set('SocialMediaIconsBar', SocialMediaIconsBar);
components.set('SpotlightCarousel', SpotlightCarousel);
components.set('SpotlightCarouselv2', SpotlightCarouselv2);
components.set('SubNavRelatedLinks', SubNavRelatedLinks);
components.set('ThreeColumnLayout', ThreeColumnLayout);
components.set('TimelineCarousel', TimelineCarousel);
components.set('ToolsAndAppsCoveoResultTemplate', ToolsAndAppsCoveoResultTemplate);
components.set('ToolsList', ToolsList);
components.set('ToolsListing', ToolsListing);
components.set('ToolsSearch', ToolsSearch);
components.set('TwitterFeed', TwitterFeed);
components.set('TwoColumnLeftLayout', TwoColumnLeftLayout);
components.set('TwoColumnLeftLayoutv2', TwoColumnLeftLayoutv2);
components.set('TwoColumnLeftLayoutv3', TwoColumnLeftLayoutv3);
components.set('TwoColumnRightLayout', TwoColumnRightLayout);
components.set('TwoColumnRightLayoutv2', TwoColumnRightLayoutv2);
components.set('TwoColumnRightLayoutv3', TwoColumnRightLayoutv3);
components.set('UcCoveoDidYouMean', UcCoveoDidYouMean);
components.set('VideoInline', VideoInline);
components.set('VideoInlineLeftRight', VideoInlineLeftRight);
components.set('VideoSpotlight', VideoSpotlight);
components.set('VideoSpotlightHero', VideoSpotlightHero);
components.set('VimeoVideoSpotlight', VimeoVideoSpotlight);
components.set('Welcome', Welcome);
components.set('WelcomeImageBanner', WelcomeImageBanner);
components.set('WelcomeTwoColumnLayout', WelcomeTwoColumnLayout);
components.set('YoutubeCoveoResultTemplate', YoutubeCoveoResultTemplate);
components.set('CoveoAnalytics', CoveoAnalytics);
components.set('CoveoAutomaticBoosting', CoveoAutomaticBoosting);
components.set('CoveoBreadcrumb', CoveoBreadcrumb);
components.set('CoveoDefaultResultTemplate', CoveoDefaultResultTemplate);
components.set('CoveoDidYouMean', CoveoDidYouMean);
components.set('CoveoExternalComponentsSection', CoveoExternalComponentsSection);
components.set('CoveoExternalContent', CoveoExternalContent);
components.set('CoveoFacet', CoveoFacet);
components.set('CoveoFacetSlider', CoveoFacetSlider);
components.set('CoveoFacetsSection', CoveoFacetsSection);
components.set('CoveoGlobalSearchSection', CoveoGlobalSearchSection);
components.set('CoveoHostedSearchPage', CoveoHostedSearchPage);
components.set('CoveoItemResultTemplate', CoveoItemResultTemplate);
components.set('CoveoModularFrame', CoveoModularFrame);
components.set('CoveoPager', CoveoPager);
components.set('CoveoQueryFilter', CoveoQueryFilter);
components.set('CoveoQueryRanking', CoveoQueryRanking);
components.set('CoveoQuerySummary', CoveoQuerySummary);
components.set('CoveoResultList', CoveoResultList);
components.set('CoveoResultsHeaderSection', CoveoResultsHeaderSection);
components.set('CoveoResultsPerPage', CoveoResultsPerPage);
components.set('CoveoResultsSection', CoveoResultsSection);
components.set('CoveoResultsSortsSection', CoveoResultsSortsSection);
components.set('CoveoResultsSummarySection', CoveoResultsSummarySection);
components.set('CoveoSearchbox', CoveoSearchbox);
components.set('CoveoSearchInterface', CoveoSearchInterface);
components.set('CoveoSearchResources', CoveoSearchResources);
components.set('CoveoSearchSection', CoveoSearchSection);
components.set('CoveoSitecoreInstanceFilter', CoveoSitecoreInstanceFilter);
components.set('CoveoSort', CoveoSort);
components.set('CoveoTab', CoveoTab);
components.set('CoveoTabsSection', CoveoTabsSection);

export default function componentFactory(componentName) {
  return components.get(componentName);
};
